export function encodeId(value: string | number): string {
  return btoa(String(value));
}

export function encodeUrlBid(value: string): string {
  if (!value.startsWith('http')) {
    return value;
  }
  try {
    const url = new URL(value);
    const bid = url.searchParams.get('bid');
    if (bid && /^\d+$/.test(bid)) {
      url.searchParams.set('bid', encodeId(bid));
      return url.toString();
    }
  } catch {
    // not a valid URL, return as-is
  }
  return value;
}
